export const CREATE_MANUAL_PAYOUT_DIALOG_TEST_ID =
  'create-manual-payout-dialog';

// Text
export const CANCEL_TEXT = 'Cancel';
export const YES_TEXT = 'Yes';
export const NO_TEXT = 'No';
export const NEXT = 'Next';
export const ARE_YOU_SURE =
  'Are you sure you want to exit your unfinished manual payout request?';
export const IT_WILL_BE_DELETED = 'It will be deleted.';
export const FINISH_AND_CLOSE = 'Finish and close';
export const VIEW_REQUESTS = 'View payout requests';
export const SUCCESSFULLY_CREATED = 'Payout request successfully created';
export const EXIT_UNFINISHED_MANUAL_PAYOUT_REQUEST =
  'Exit unfinished manual payout request';
export const PAYOUT_NEEDS_APPROVAL =
  'The payout request has been sent for approval. It needs to be approved before it will be processed. Reviewers have been notified by email.';
export const DATA_REQUIRED_SELECTOR_TEST_ID = 'data-required';
export const FINISHED_CHECKMARK = 'finished-checkmark';

// UI elements
export const INSTRUMENT_SELECT_TEST_ID =
  'create-manual-payout-product-local-instrument';
export const CORRIDOR_SELECT_TEST_ID = 'create-manual-payout-product-corridor';

export const PAYOUT_REQUEST_STEP_NEXT_BUTTON =
  'payout-request-step-next-button';
export const WEBSITE_STEP_NEXT_BUTTON_TEST_ID = 'website-step-next-button';
export const SENDER_STEP_NEXT_BUTTON = 'sender-step-next-button';
export const RECEIVER_STEP_NEXT_BUTTON = 'receiver-step-next-button';
export const SUMMARY_STEP_BUTTON_TEST_ID = 'summary-step-button';

export const PREFILL_SENDER_SWITCH_TEST_ID = 'prefill-sender-switch';
export const SENDER_SAME_AS_RECEIVER_SWITCHFIELD_TEST_ID =
  'create-manual-payout-sender-same-as-receiver';
export const RECEIVER_SELECT_TEST_ID = 'receiver-select';
export const SUBMIT_PAYOUT_TEST_ID = 'submit-payout';
export const SUCCESS_TEST_ID = 'successful-submission';
export const VIEW_PAYOUT_REQUESTS_TEST_ID = 'view-payout-requests-button';
